export default __webpack_public_path__ + "static/media/jeep.57c46ad5.svg";